import { cn } from '@/shared/lib'
import { useNoiseStatus } from '../model/noise-status'
import { useNoiseSuppression } from '../model/noise-store'

// Подзаголовок отражает фактическое состояние обработки: включённый тумблер
// при упавшем шумодаве не выглядит как «всё хорошо».
function statusLine(enabled: boolean, status: string): { text: string; broken: boolean } {
  if (!enabled) return { text: 'Убирает фоновый шум микрофона (DeepFilterNet3)', broken: false }
  switch (status) {
    case 'active':
      return { text: 'Работает: фоновый шум подавляется (DeepFilterNet3)', broken: false }
    case 'loading':
      return { text: 'Включается: загрузка модели…', broken: false }
    case 'pending':
      return { text: 'Включится, когда появится микрофон', broken: false }
    case 'failed':
      return { text: 'Не включился: звук идёт без обработки', broken: true }
    case 'unsupported':
      return { text: 'Не поддерживается этим устройством', broken: true }
    default:
      return { text: 'Убирает фоновый шум микрофона (DeepFilterNet3)', broken: false }
  }
}

export function NoiseSuppressionToggle() {
  const enabled = useNoiseSuppression((s) => s.enabled)
  const setEnabled = useNoiseSuppression((s) => s.setEnabled)
  const level = useNoiseSuppression((s) => s.level)
  const setLevel = useNoiseSuppression((s) => s.setLevel)
  const status = useNoiseStatus()
  const { text, broken } = statusLine(enabled, status)

  return (
    <div className="flex flex-col gap-3 rounded-control border border-border-default px-4 py-3">
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        onClick={() => setEnabled(!enabled)}
        className="flex w-full items-center justify-between gap-4 text-left"
      >
        <span className="flex flex-col gap-0.5">
          <span className="text-sm text-text-primary">Шумоподавление</span>
          <span className={cn('text-xs', broken ? 'text-accent' : 'text-text-secondary')}>
            {text}
          </span>
        </span>
        <span
          aria-hidden
          className={cn(
            'relative h-5 w-9 shrink-0 rounded-full border transition-colors',
            enabled ? 'border-border-accent bg-accent' : 'border-border-default bg-bg-raised',
          )}
        >
          <span
            className={cn(
              'absolute top-0.5 size-3.5 rounded-full bg-text-primary transition-[left]',
              enabled ? 'left-[1.125rem]' : 'left-0.5',
            )}
          />
        </span>
      </button>
      {/* Уровень — atten_lim дБ (0–100): сколько максимум давить шум.
          При выключенном тумблере уровень менять не к чему. */}
      <label
        className={cn(
          'flex flex-col gap-1.5 transition-opacity',
          !enabled && 'pointer-events-none opacity-40',
        )}
      >
        <span className="flex items-center justify-between text-xs text-text-secondary">
          <span>Уровень подавления</span>
          <span className="font-mono">{level} дБ</span>
        </span>
        <input
          type="range"
          min={0}
          max={100}
          step={1}
          value={level}
          disabled={!enabled}
          aria-label="Уровень шумоподавления"
          onChange={(event) => setLevel(Number(event.target.value))}
          className="accent-accent"
        />
      </label>
    </div>
  )
}
